@if (showIcon) {
  <span
    class="badge-icon tw-w-2 tw-h-2 tw-rounded-full tw-mr-1.5 {{ iconClasses }}"
  ></span>
}

@if(iconName && storyDesign) {
  <i-icon
    [name]="iconName"
    [width]="'tw-w-4'"
    [height]="'tw-h-4'"
    class="tw-mr-[6px]"
  ></i-icon>
}

@if (prefix()) {
  <span
    class="badge-prefix tw-w-2 tw-h-2 tw-rounded-full tw-mr-1.5 {{ iconClasses }}"
  >
    {{ prefix() }}
  </span>
}

<span>{{ label }}</span>

@if (postfix()) {
  <span
    class="badge-postfix tw-w-2 tw-h-2 tw-rounded-full tw-mr-1.5 {{ iconClasses }} !{{textSizeClass}}"
  >
    {{ postfix() }}
  </span>
}
